import { AxiosResponse } from "axios";

import axiosInstance from "@/lib/axios";

import { CheckOut, MonthlyAttendance, Reason } from "../types/Check";

export interface AttendanceAPI {
  sendIn: (value: FormData) => Promise<AxiosResponse>;
  sendOut: (value: CheckOut) => Promise<AxiosResponse>;
  reason: (value: Reason) => Promise<AxiosResponse>;
  getStats: (args: {
    params: { month_year: string };
  }) => Promise<MonthlyAttendance>;
  getAttendanceId: () => Promise<{
    attendance_type: string;
    check_in_time: string;
    check_out_time: null;
    id: string;
    is_face_id_verified: boolean;
    late_reason_text: string | null;
    late_reason_type: null;
  }>;
}

export const attendance: AttendanceAPI = {
  sendIn: (value: FormData) =>
    axiosInstance
      .post("/yetakchi/attendance/check-in/face-verify/", value, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => res),
  sendOut: ({ attendance_id, ...value }: CheckOut) =>
    axiosInstance
      .post("/yetakchi/attendance/check-out/", {
        uuid: attendance_id,
        ...value,
      })
      .then((res) => res),
  reason: (value: Reason) =>
    axiosInstance
      .post("/yetakchi/attendance/mark-absent/", value)
      .then((res) => res),
  getStats: ({ params }: { params: { month_year: string } }) =>
    axiosInstance
      .get<MonthlyAttendance>("/yetakchi/attendance/monthly/", { params })
      .then((res) => res.data),
  getAttendanceId: () =>
    axiosInstance
      .get<
        {
          attendance_type: string;
          check_in_time: string;
          check_out_time: null;
          id: string;
          is_face_id_verified: boolean;
          late_reason_text: string | null;
          late_reason_type: null;
        }[]
      >("/yetakchi/attendance/today/")
      .then((res) => res.data?.[0]),
};
